import './header.css'
import Typewriter from 'typewriter-effect';
import { FiDownloadCloud, FiArrowRight } from 'react-icons/fi'

import Socials from '../../components/socials/Socials'

import avatar from '../../assets/avatar.png'

const Header = () => {
  return (
    <header className="header" id="home">
      <img className="header_avatar" src={avatar} alt="Prince Geary Dymosco" />
      <div className="header_terminal">
        <span className="header_terminal-status">SYS.INIT</span>
        <div className="header_greetings">$ echo "Hello" && meet</div>
        <h1 className="header_fullname">&lt;PRINCE /&gt;</h1>
      </div>
      <div className="header_typewriter-container">
        <Typewriter
          options={{
            strings: [
              '<span class="header_typewriter">an <span class="header_occupation">Electronics Engineer</span></span>',
              '<span class="header_typewriter">turned <span class="header_occupation">Fullstack Developer</span>.</span>'],
            autoStart: true,
            loop: true,
            delay: 100,
            deleteSpeed: 25,
            pauseFor: 500
          }}
        />
      </div>
      <Socials />
      <div className="header_CTA">
        <a className="btn btn-primary" target="_blank" href="https://docs.google.com/document/d/1D4E5xV_8zrNWat-OBRE1G4wK4vQCUb3i/edit?usp=sharing&ouid=114245434864134386552&rtpof=true&sd=true" rel="noopener noreferrer">Resume&nbsp;<FiDownloadCloud/></a>
        <a className="btn btn-secondary" href="#connect">Get in Touch&nbsp;<FiArrowRight/></a>
      </div>
    </header>
  )
}

export default Header
